import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Grid } from "@material-ui/core";
import LayersIcon from "@mui/icons-material/Layers";
import { CountryContext } from "../MainComponent";
import AllCategoriesMenu from "./AllCategoriesMenu";

const SubMenu = (props: any) => {
  const { store } = useContext(CountryContext);
  const [activeCategory, setActiveCategory] = useState(null);
  const location = useLocation();

  const findMatchingCategory = (path: string) => {
    if (!props.menuData) return null;

    const exactMatch = props.menuData.find(
      (item: any) => item.url_path === path
    );
    if (exactMatch) return exactMatch;

    return props.menuData.find((item: any) => {
      return (
        path.startsWith(`${item.url_path}/`) ||
        item.url_path.startsWith(`${path}/`)
      );
    });
  };

  useEffect(() => {
    if (location.pathname.includes("/category/")) {
      const categoryPath = location.pathname
        .split("/category/")[1]
        ?.replace(".html", "");

      const matchingCategory = findMatchingCategory(categoryPath);
      setActiveCategory(matchingCategory || null);
    }else if (location.pathname.includes("/brands") || location.pathname.includes("/brand")) {
      const brandsCategory = props.menuData?.find((item: any) => item.name === "Brands");
      setActiveCategory(brandsCategory || null);
    } else {
      setActiveCategory(null);
    }
    //eslint-disable-next-line
  }, [location.pathname, props.menuData]);

  const handleCategoryClick = () => {
    setActiveCategory(null);
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "black",
        display: { xs: "none", md: "block" },
      }}
    >
      <div className="sub-header-wrap">
        <Grid container>
          <Grid item xs={12}>
            {props.menuData ? (
              <ul className="category-wrap list-unstyled">
                <AllCategoriesMenu
                  menuData={props.menuData}
                  activeCategory={activeCategory}
                  setActiveCategory={setActiveCategory}
                />
                {props.menuData &&
                  props.menuData?.map((item: any, index: any) =>
                    item?.is_visible_top ? (
                      <li
                        key={index}
                        className={
                          item === activeCategory
                            ? "index-" + index + " activeCategory "
                            : "index-" + index
                        }
                      >
                        {index === 0 && (
                          <LayersIcon
                            style={{
                              fontSize: 24,
                              color: "#00BCD4",
                              marginRight: "8px",
                            }}
                          />
                        )}
                        {item?.name === "Brands" ? (
                          <Link
                          to={`/${store}/brands.html`}
                          className="sub-head-btn"
                          onClick={() => handleCategoryClick()}
                        >
                          {item?.name}
                        </Link>
                        ) : (
                          <Link 
                            to={`/${store}/category/${item?.url_path}.html`}
                            className="sub-head-btn"
                            onClick={() => handleCategoryClick()}
                          >
                            {item?.name}
                          </Link>
                        )}
                      </li>
                    ) : (
                      ""
                    )
                  )}
              </ul>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default React.memo(SubMenu);
